export function canvasToBlob(
  canvas: HTMLCanvasElement,
  imageType = "image/png",
  quality = 1
): Promise<Blob> {
  return new Promise((res, rej) => {
    try {
      canvas.toBlob(
        (blob: Blob | null) => {
          if (blob) {
            res(blob);

            return;
          }

          rej(new Error("canvasToBlob: blob null"));
        },
        imageType,
        quality
      );
    } catch (ex) {
      rej(ex);
    }
  });
}
